import { render, staticRenderFns } from "./bottomIntroduce.vue?vue&type=template&id=ad528c44&scoped=true&"
import script from "./bottomIntroduce.vue?vue&type=script&lang=js&"
export * from "./bottomIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./bottomIntroduce.vue?vue&type=style&index=0&id=ad528c44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad528c44",
  null
  
)

export default component.exports